/* GLADIATOR HOOPS — anchor landing
   The header is position:sticky, so a plain #hash jump parks the target
   underneath it. Long pages also keep growing after the jump as lazy images,
   the 3D viewer and videos resolve, which drags the target back off screen —
   the visitor ends up somewhere random and thinks the link did nothing.
   scroll-padding-top fixes the offset; the re-jumps fix the drift.
   Any real user input cancels the re-jumps immediately. */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('.gh-header');
    var headerH = header ? Math.round(header.getBoundingClientRect().height) : 72;
    document.documentElement.style.scrollPaddingTop = (headerH + 14) + 'px';

    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target;
    try { target = document.querySelector(hash); } catch (err) { return; }
    if (!target) return;

    var cancelled = false;
    function cancel() { cancelled = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (evt) {
      window.addEventListener(evt, cancel, { passive: true, once: true });
    });

    function jump() {
      if (cancelled) return;
      target.scrollIntoView({ block: 'start' });
    }

    jump();
    window.addEventListener('load', function () {
      [80, 400, 1000, 1800].forEach(function (ms) { setTimeout(jump, ms); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
